// Product page description toggle
const descToggleButton = document.querySelector("[data-description-toggle-btn]");

if (descToggleButton) {
  descToggleButton.addEventListener("click", () => {
    const productDesc = descToggleButton.closest("[data-product-description]");

    if (productDesc.dataset.productDescription === "close") {
      productDesc.dataset.productDescription = "open";
    } else if (productDesc.dataset.productDescription === "open") {
      productDesc.dataset.productDescription = "close";
    }
  })
}



// Product page colour swatches
const swatchToggleButton = document.querySelector("[data-swatch-toggle-btn]");

if (swatchToggleButton) {
  swatchToggleButton.addEventListener("click", () => {
    const swatchContent = swatchToggleButton.closest("[data-swatch-wrapper]")
                                .querySelector("[data-swatch-content]");
    if (swatchContent.dataset.swatchContent === "close") {
      swatchContent.dataset.swatchContent = "open";
      swatchToggleButton.dataset.swatchToggleBtn = "open";
    } else if (swatchContent.dataset.swatchContent === "open") {
      swatchContent.dataset.swatchContent = "close";
      swatchToggleButton.dataset.swatchToggleBtn = "close";
    }
  })
}



// product quantity change
const quantityButtons = document.querySelectorAll("[data-quantity-btn]");

quantityButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const quantityInput = button.closest("div")
                                .querySelector("[data-quantity-input]");

    let newQuantity = Number(quantityInput.value);
    if (button.dataset.quantityBtn === "minus") {
      // minus button updates cart
      newQuantity = Math.max(0, newQuantity - 1);
      console.log("minue 1");
    } else if (button.dataset.quantityBtn === "plus") {
      // plus button updates cart
      newQuantity += 1;
      console.log("add 1");
    }

    console.log("update qty")
    quantityInput.value = newQuantity;
  })
})



// Product page dropdown
const dropdownButtons = document.querySelectorAll("[data-dropdown-btn]");

dropdownButtons.forEach((button) => {
  if (button) {
    button.addEventListener("click", () => {
      const dropdown = button.closest("[data-dropdown]");

      if (dropdown.dataset.dropdown === "close") {
        dropdown.dataset.dropdown = "open";
      } else if (dropdown.dataset.dropdown === "open") {
        dropdown.dataset.dropdown = "close";
      }
    })
  }
})



const selectedVariants = JSON.parse(document.querySelector("[data-selected-variant]"));


// Product page select variant options
const variantOptionSelectors = document.querySelectorAll("[data-product-variant-options]");

if (variantOptionSelectors) {
  variantOptionSelectors.forEach((selector) => {
    if (selector instanceof HTMLSelectElement) {
      selector.addEventListener("change", () => {
        // remove the selected attribute from the default variant option
        Array.from(selector.options)
          .find((option) => option.getAttribute("selected"))
          .removeAttribute("selected");

        // set selected attribute for the user selected option
        const option = selector.options[selector.selectedIndex];
        option.setAttribute("selected", "selected");
        console.log("Variant selection updated: " + option.value)
      })
    }
  })
}
